import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import classNames from 'classnames'

import Markdown from '../Markdown/Markdown'
import { getImageUrl } from '../../utils'
import styles from './ProfileModal.module.scss'
import Close from '../../assets/images/close.svg'

const ProfileModal = ({ open, data, setOpen }) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsClosing(false)
      setOpen()
    }, 400)
  }

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        dialogClassName={classNames(styles['right-side-modal'], {
          [styles['slide-out']]: isClosing,
        })}
        contentClassName={classNames(styles['right-side-modal-content'])}
        backdropClassName={isClosing ? styles['slide-out'] : ''}
        animation={false}
      >
        <div
          className={classNames(
            styles['close-container'],
            'flex justify-end pb-6 mb-6 md:pb-8 md:mb-8'
          )}
        >
          <img
            src={Close}
            alt="Close"
            className="object-none cursor-pointer h-6 w-6 md:h-8 md:w-8"
            onClick={handleClose}
          />
        </div>
        <div className="grid grid-cols-3 gap-8 mb-8">
          <div
            className={classNames(styles['image-container'], 'overflow-hidden')}
          >
            <img
              src={getImageUrl(data?.image)}
              alt="Profile"
              className="block w-full h-auto"
            />
          </div>
          <div className="col-span-2">
            <div className={classNames(styles.name)}>
              {data?.title} {data?.firstname} {data?.middlename}{' '}
              {data?.lastname}
            </div>
            <div className={classNames(styles.designation)}>
              {data?.designationdetails}
            </div>
          </div>
        </div>
        <Markdown
          content={data?.description}
          className={classNames(styles.description)}
        />
      </Modal>
    </>
  )
}

export default ProfileModal
